// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Components
import ElementDragPreview from './ElementDragPreview';

// Utils
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { getTranslationStyles } from '../../utils/cssUtil';

// Styles
import './ElementDragPreviewPositioner.scss';

const getTranslation = ({ item, element }) => {
    const unscaledElementOffset = get(['unscaledElementOffsetsMap', getElementId(element)], item);
    return unscaledElementOffset ? getTranslationStyles(unscaledElementOffset) : null;
};

class ElementDragPreviewPositioner extends React.Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { element, elementId, gridSize, currentBoardId, permissions } = this.props;

        return (
            <div className="ElementDragPreviewPositioner" style={getTranslation(this.props)}>
                <ElementDragPreview
                    permissions={permissions}
                    currentBoardId={currentBoardId}
                    elementId={elementId}
                    element={element}
                    isPresentational
                    gridSize={gridSize}
                />
            </div>
        );
    }
}

ElementDragPreviewPositioner.propTypes = {
    elementId: PropTypes.string.isRequired,
    element: PropTypes.object.isRequired,
    gridSize: PropTypes.number.isRequired,
    currentBoardId: PropTypes.string.isRequired,
    permissions: PropTypes.number,
};

export default ElementDragPreviewPositioner;
